module.exports = __webpack_public_path__ + "assets/img/2.13111aea.png";